var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlatformPic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4359_16195)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.707031,
    width: 84,
    height: 84,
    rx: 42,
    fill: "url(#paint0_linear_4359_16195)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.18 49.4262V52.7862C51.18 57.2662 57.62 59.2262 57.62 59.2262C57.62 59.2262 50.2 64.8262 42.5 64.8262C34.8 64.8262 27.38 59.2262 27.38 59.2262C27.38 59.2262 33.8707 57.2662 33.82 52.7862C33.7693 48.3062 33.8032 45.6742 33.7693 37.9989C29.7564 32.7973 30.014 29.3063 32.2083 26.8512C39.56 18.6262 59.58 21.4262 59.58 21.4262C59.58 21.4262 61.4482 41.5843 57.2 47.4662C55.38 49.9862 51.18 49.4262 51.18 49.4262Z",
    fill: "url(#paint1_linear_4359_16195)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M51.18 49.4264C45.02 48.7264 41.38 46.0664 41.38 46.0664C43.6781 49.4663 47.1804 51.8679 51.18 52.7864V49.4264Z",
    fill: "url(#paint2_linear_4359_16195)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9 67.7119C74.5656 73.1318 76.1 85.6319 76.1 85.6319H8.90002C8.90002 85.6319 10.435 73.1304 13.1 67.7119C15.7651 62.2933 31.328 57.2676 31.328 57.2676C34.3277 63.4256 50.7903 63.4256 53.6639 57.2656C53.6639 57.2656 69.2344 62.2919 71.9 67.7119Z",
    fill: "url(#paint3_linear_4359_16195)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.38 78.5466C41.38 78.325 41.4457 78.1085 41.5688 77.9243C41.6918 77.7401 41.8667 77.5966 42.0714 77.5118C42.2761 77.427 42.5012 77.4049 42.7185 77.4481C42.9358 77.4913 43.1353 77.598 43.292 77.7546C43.4486 77.9112 43.5553 78.1108 43.5985 78.3281C43.6417 78.5453 43.6195 78.7705 43.5347 78.9752C43.45 79.1798 43.3064 79.3547 43.1222 79.4778C42.9381 79.6009 42.7215 79.6666 42.5 79.6666C42.203 79.6666 41.9181 79.5486 41.708 79.3385C41.498 79.1285 41.38 78.8436 41.38 78.5466ZM41.38 72.9466C41.38 72.725 41.4457 72.5085 41.5688 72.3243C41.6918 72.1401 41.8667 71.9966 42.0714 71.9118C42.2761 71.827 42.5012 71.8049 42.7185 71.8481C42.9358 71.8913 43.1353 71.998 43.292 72.1546C43.4486 72.3112 43.5553 72.5108 43.5985 72.7281C43.6417 72.9453 43.6195 73.1705 43.5347 73.3752C43.45 73.5798 43.3064 73.7547 43.1222 73.8778C42.9381 74.0009 42.7215 74.0666 42.5 74.0666C42.203 74.0666 41.9181 73.9486 41.708 73.7385C41.498 73.5285 41.38 73.2436 41.38 72.9466ZM41.38 67.3466C41.38 67.125 41.4457 66.9085 41.5688 66.7243C41.6918 66.5401 41.8667 66.3966 42.0714 66.3118C42.2761 66.227 42.5012 66.2049 42.7185 66.2481C42.9358 66.2913 43.1353 66.398 43.292 66.5546C43.4486 66.7112 43.5553 66.9108 43.5985 67.1281C43.6417 67.3453 43.6195 67.5705 43.5347 67.7752C43.45 67.9798 43.3064 68.1547 43.1222 68.2778C42.9381 68.4009 42.7215 68.4666 42.5 68.4666C42.203 68.4666 41.9181 68.3486 41.708 68.1385C41.498 67.9285 41.38 67.6436 41.38 67.3466V67.3466Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2234 29.6047C36.333 28.84 35.2511 28.3251 33.7218 29.1197C30.096 31.0022 32.84 38.2262 36.06 38.2262C36.9 38.2262 37.3178 40.8643 33.5778 42.7062C33.5778 39.7662 29.0978 32.4862 28.7058 25.858C24.1978 24.1794 25.3178 17.4631 28.4127 17.4631C27.9188 11.3064 37.7778 8.12618 41.5954 11.6595C45.4778 7.00618 55.2778 9.38618 55.8695 13.4232C62.6082 9.82606 67.0378 20.1662 60.728 24.1803C58.1316 25.8323 52.0578 26.4609 43.2902 26.4609C41.9666 26.4609 41.2252 26.7896 41.5954 28.4262C42.3119 31.5975 40.6484 33.595 37.2234 29.6047Z",
    fill: "url(#paint4_linear_4359_16195)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4359_16195",
    x1: 42.5,
    y1: 84.707,
    x2: 42.5,
    y2: 0.707031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBEAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4359_16195",
    x1: 43.6845,
    y1: 20.9668,
    x2: 43.6845,
    y2: 64.8262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6864E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB965E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4359_16195",
    x1: 49.3278,
    y1: 47.3298,
    x2: 47.6114,
    y2: 53.8293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB9154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4359_16195",
    x1: 42.5,
    y1: 57.2656,
    x2: 42.5,
    y2: 85.6319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4359_16195",
    x1: 44.7354,
    y1: 9.10547,
    x2: 44.7354,
    y2: 42.7062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4359_16195"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.707031,
    width: 84,
    height: 84,
    rx: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformPic);
export default __webpack_public_path__ + "static/media/platformPic.960165101602f5f9d12df38d51c2eb05.svg";
export { ForwardRef as ReactComponent };